import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import CardDefault from '../CardPage/CardDefault/index';
import { SvgIcon } from 'components/SvgIcon';
import { pixelService, enPixelPath } from 'services/PixelService';

const styles = require('./cardWidget.css');

interface IState extends IStateBase {
  data: IThankYouPage;
}

interface IProps {
  infos: any;
}

export default class CardWidgetPage extends BaseComponent<IState, IProps>{

  constructor(props: any) {
    super(props);

    window.parent.postMessage({ EdzWidgetPayment: props.infos }, '*');
  }

  componentDidMount() {
    pixelService.track(enPixelPath.THANKYOU);
  }

  closeWidget = () => {
    window.parent.postMessage('EdzWidgetClose', '*');
  }

  render() {
    return (
      <div className={styles.component}>
        <div className='chk-content-container'>
          <div className='chk-container'>
            <button id='chk-widget-close-button' className='chk-multiStep__closeForm theme-button' onClick={this.closeWidget}>
              <SvgIcon name='closeIcon' />
            </button>
            <CardDefault infos={this.props.infos} />
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/CardWidgetPage/index.tsx